import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchFeaturedCategoryAPI } from "./featuredCategoryAPI";

export const fetchFeaturedCategoryData = createAsyncThunk(
    "home/fetchFeaturedCategoryData",
    async () => {
        const data = await fetchFeaturedCategoryAPI();
        return data
    }
)

const featuredCategorySlice = createSlice({
    name: "featuredCategory",
    initialState: {
        categories: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchFeaturedCategoryData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchFeaturedCategoryData.fulfilled, (state, action) => {
            state.loading = false;
            state.categories = action.payload.data || {};
        })
        .addCase(fetchFeaturedCategoryData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default featuredCategorySlice.reducer;